export const marketConstants = {
    GETALL_REQUEST: 'MARKETS_GETALL_REQUEST',
    GETALL_SUCCESS: 'MARKETS_GETALL_SUCCESS',
    GETALL_FAILURE: 'MARKETS_GETALL_FAILURE',

    RETRIEVE_REQUEST: 'MARKET_RETRIEVE_REQUEST',
    RETRIEVE_SUCCESS: 'MARKET_RETRIEVE_SUCCESS',
    RETRIEVE_FAILURE: 'MARKET_RETRIEVE_FAILURE',

    CURRENT_CLEAR: 'MARKET_CURRENT_CLEAR',

}
